import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import HowItWorks from '../components/HowItWorks'
import ScrollToTop from '../components/ScrollToTop'

function HowWorks() {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }
    return (
        <div>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} />

            <Navbar toggle={toggle} />

            <HowItWorks />

            <Footer />
        </div>
    )
}

export default HowWorks